export const getDateFromTimeZone = (timeZone: string): Date => (
  new Date(new Date().toLocaleString('en-US', { timeZone }))
);
const zeroPadding = (num: number, len: number): string => (
  `${Array(len).join('0')}${num}`.slice(-len)
);

// Convert military time number to military string, ie: from 945 to '09:45'
export const formatMilitaryTime = (time: number): string => {
  const adjustedTime = zeroPadding(time, 4);
  return `${adjustedTime.substring(0, 2)}:${adjustedTime.substring(adjustedTime.length - 2)}`;
};

interface IDateTime {
  date: string;
  offset: number;
  time: string;
}

export const getOffsetDate = (dateTime: IDateTime): Date => {
  const { date, offset, time } = dateTime;
  return new Date(`${date} ${formatMilitaryTime(Number(time))} ${offset}`);
};

export const fromMilitaryToStandardTime = (militaryTimeNumber: number): string => {
  const timeMoment = militaryTimeNumber >= 1200 ? 'pm' : 'am';
  let timeNumber = militaryTimeNumber;

  let formattedTime;

  if (militaryTimeNumber > 1259) {
    timeNumber -= 1200;
  }

  if (militaryTimeNumber === 0) {
    return `12${timeMoment}`;
  }

  const cutOff = timeNumber < 1000 ? 1 : 2;
  const timeHours = timeNumber.toString().slice(0, cutOff);
  const timeMinutes = timeNumber.toString().slice(cutOff);

  if (timeMinutes !== '00') {
    formattedTime = `${timeHours}:${timeMinutes}${timeMoment}`;
  } else {
    formattedTime = `${timeHours}${timeMoment}`;
  }

  return formattedTime;
};

export const getCurrentTimeInMilitary = (dateTime: Date): number => {
  const hours = dateTime.getHours().toString();
  const minutes = dateTime.getMinutes().toString().padStart(2, '0');
  return +(hours + minutes);
};

export const convertDateToIsoString = (dateTime: Date): string => {
  let isoTime;
  try {
    isoTime = dateTime.toISOString();
  } catch {
    isoTime = '';
  }
  return isoTime;
};

export const isRawTimeValid = (time: number): boolean => {
  return time >= 0 && time <= 2400;
};
